// Canonical public origin for all share links. Preview/dev environments
// hibernate and show "Preview Unavailable" to recipients, so shared URLs
// must always point at the canonical public domain.
export const PROD_ORIGIN =
  process.env.REACT_APP_PUBLIC_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

export function shareOrigin() {
  return PROD_ORIGIN;
}
